import styled, { css } from 'styled-components'
import media from 'styled-media-query'

export const Wrapper = styled.div`
  ${({ theme }) => css`
    color: ${theme.colors.primary};
    svg {
      width: 40px;
    }
    ${media.lessThan('large')`
    color: ${theme.colors.white};
    svg{
      width:40px;
    }
    `}
  `}
`
